import { useTranslation } from 'react-i18next'
import { Button, Dialog, DialogActions, DialogContent } from '@mui/material'

type Props = {
  children: React.ReactNode
  open: boolean
  label: string
  onCancel?: () => void
  onSubmit: () => void
}
export const ConfirmDialog = (props: Props) => {
  const { children, open, label, onCancel, onSubmit } = props
  const { t } = useTranslation()

  return (
    <Dialog open={open} fullWidth>
      <DialogContent sx={{ whiteSpace: 'pre-wrap' }}>{children}</DialogContent>
      <DialogActions>
        {onCancel && (
          <Button variant="outlined" sx={{ minWidth: '100px' }} onClick={onCancel}>
            {t('common.cancel')}
          </Button>
        )}
        <Button variant="contained" sx={{ minWidth: '100px' }} onClick={onSubmit}>
          {label}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
